import { render, staticRenderFns } from "./OrganizationProofStatus.vue?vue&type=template&id=05b0c7d2"
import script from "./OrganizationProofStatus.vue?vue&type=script&lang=ts"
export * from "./OrganizationProofStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports